import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { AppHeader } from './AppHeader';
import ProjectSidebar from './ProjectSidebar';

interface AppLayoutProps {
  children: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const currentProjectId = useSelector((state: RootState) => state.project.projectId);
  const showSidebar = !!currentProjectId;

  return (
    <div className="h-screen bg-gray-50 flex flex-col overflow-hidden">
      {/* Header */}
      <AppHeader />

      {/* Main layout */}
      <div className="flex-1 flex overflow-hidden">
        {/* Project Sidebar - Only shown when project is selected */}
        {showSidebar && <ProjectSidebar />}

        {/* Main content */}
        <main className="flex-1 relative overflow-y-auto focus:outline-none">{children}</main>
      </div>
    </div>
  );
};
